import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { evaluationItemType, referenceType } from 'constants/types';
import { WysiwygEditor } from 'components/Shared/sharedComponents';
import { Divider } from 'components/Shared/sharedStyle';
import { getSanctionsListSectionNum } from 'utils/candidateFormSections';
import { textBoxesRefsNames } from 'components/CandidateView/configCandidateView';
import StatusButtons from 'components/CandidateView/StatusButtons';

const SanctionsList = ({ textBoxesRefs, evaluation, defaultEvaluation, updateEvaluationStatus }) => {
  const { t } = useTranslation();
  const sectionNumber = getSanctionsListSectionNum() + 1;
  const sectionTitle = t('candidateViewSection.sanctionsList');

  return (
    <>
      <h2>{`${sectionNumber}. ${sectionTitle}`}</h2>
      <WysiwygEditor
        defaultValue={defaultEvaluation?.comment}
        editorRef={textBoxesRefs}
        name={textBoxesRefsNames?.sanctionsListComment}
        sectionTitle={sectionTitle}
        saveRefInAnotherRef
      />
      <StatusButtons value={evaluation} evaluationKey="sanctionsList" onClick={updateEvaluationStatus} />
      <Divider />
    </>
  );
};

SanctionsList.propTypes = {
  textBoxesRefs: referenceType.isRequired,
  defaultEvaluation: evaluationItemType.isRequired,
  evaluation: PropTypes.number,
  updateEvaluationStatus: PropTypes.func.isRequired,
};

export default SanctionsList;
